import React from 'react';
import { useFela } from 'react-fela';
import { applySpaceMultiplier } from '../../utils/apply-space-multiplier';
import { responsiveNumberOrStringProp } from '../../utils/prop-types';
import { View } from '../view';
export function Spacer(_ref) {
  var size = _ref.size;

  var _useFela = useFela(),
      theme = _useFela.theme;

  var spacing = applySpaceMultiplier(theme.baselineGrid);
  return /*#__PURE__*/React.createElement(View, {
    width: spacing(size),
    basis: spacing(size)
  });
}
Spacer.defaultProps = {
  size: 1
};
Spacer.propTypes = {
  size: responsiveNumberOrStringProp
};